import useSWR from "swr";
import { simpleFetcher } from "~/api/fetcher";

interface OnboardingAppRoleAssignment {
  id?: string;
  principalId?: string;
  principalDisplayName?: string;
  principalType?: string;
  resourceId?: string;
  appRoleId?: string;
}

export function useExistingAssignments(setupToken: string) {
  return useSWR<OnboardingAppRoleAssignment[], Error>(
    `/api/v2/onboarding/microsoft/${setupToken}/assignments`,
    simpleFetcher,
  );
}
